<template>
  <v-container fluid class="mb-5">
    <v-col
      >
      <h2
        class="accent--text text-center my-3 display-3"
      >Partners &amp; Resources</h2>
      <!-- <p class="text-center overline">Updated weekly</p> -->
    </v-col>

    <v-row class="mx-6">
      <v-col
        md="4"
        sm="12"
      >
        <v-card
          class="mx-auto"
          max-width="344"
          href="http://www.nevadabof.org"
        >
          <v-img
            src="../assets/partners/NBOF final logo.jpg"
            height="200px"
            contain
          ></v-img>
        </v-card>
      </v-col>
      <v-col
        md="4"
        sm="12"
      >
        <v-card
          class="mx-auto"
          max-width="344"
          href="http://www.businessnv.gov"
        >
          <v-img
            src="../assets/partners/Nevada Department of Business and Industry Logo.jpg"
            height="200px"
            contain
          ></v-img>
        </v-card>
      </v-col>
      <v-col
        md="4"
        sm="12"
      >
        <v-card
          class="mx-auto"
          max-width="344"
          href="http://www.edawn.org"
        >
          <v-img
            src="../assets/partners/edawn hres.jpg"
            height="200px"
            contain
          ></v-img>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'LandingPartners',

  data() {
    return {
      partners: [
        {
          name: 'Nevada Business Opportunity Fund',
          src: require('../assets/partners/NBOF final logo.jpg'),
          website: 'http://www.nevadabof.org',
        },
      ]
    };
  },
};
</script>

<style lang="css" scoped>
</style>
